// HeroSlider.jsx
import React from "react";
import { motion } from "framer-motion";
import {
  SlideLeft1,
  SlideLeft2,
  SlideLeft3,
  SlideLeft4,
  SlideLeft5,
  SlideLeft6,
  SlideRight1,
  SlideRight2,
  SlideRight3,
  SlideRight4,
  SlideRight5,
  SlideRight6,
  SlideMiddle1,
  SlideMiddle2,
  SlideMiddle3,
  SlideMiddle4,
  SlideMiddle5,
  SlideMiddle6,
} from "./assets";
import styled from "styled-components";

const leftImages = [
  SlideLeft1,
  SlideLeft2,
  SlideLeft3,
  SlideLeft4,
  SlideLeft5,
  SlideLeft6,
];

const middleImages = [
  SlideMiddle1,
  SlideMiddle2,
  SlideMiddle3,
  SlideMiddle4,
  SlideMiddle5,
  SlideMiddle6,
];

const rightImages = [
  SlideRight1,
  SlideRight2,
  SlideRight3,
  SlideRight4,
  SlideRight5,
  SlideRight6,
];

const HeroSlider = () => {
  const doubledLeft = [...leftImages, ...leftImages];
  const doubledMiddle = [...middleImages, ...middleImages];
  const doubledRight = [...rightImages, ...rightImages];

  return (
    <HeroSliderWrapper>
      {/* Left Column */}
      <div className="w-1/3 flex justify-center">
        <motion.div
          className="flex flex-col gap-4"
          animate={{ y: ["0%", "-50%"] }}
          transition={{
            duration: 10,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {doubledLeft.map((img, i) => (
            <ImageStyle
              key={`left-${i}`}
              src={img}
              alt={`slide-left-${i}`}
            />
          ))}
        </motion.div>
      </div>

      {/* Middle Column */}
      <div className="w-1/3 flex justify-center">
        <motion.div
          className="flex flex-col gap-4"
          animate={{ y: ["0%", "-50%"] }}
          transition={{
            duration: 10,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {doubledMiddle.map((img, i) => (
            <ImageStyle
              key={`middle-${i}`}
              src={img}
              alt={`slide-middle-${i}`}
            />
          ))}
        </motion.div>
      </div>

      {/* Right Column */}
      <div className="w-1/3 flex justify-center">
        <motion.div
          className="flex flex-col gap-4"
          animate={{ y: ["0%", "-50%"] }}
          transition={{
            duration: 10,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {doubledRight.map((img, i) => (
            <ImageStyle
              key={`right-${i}`}
              src={img}
              alt={`slide-right-${i}`}
            />
          ))}
        </motion.div>
      </div>
    </HeroSliderWrapper>
  );
};

export default HeroSlider;

const HeroSliderWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 417px;
  overflow: hidden;
  gap: 1rem;
  z-index: 0;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(
      180deg,
      rgba(242, 244, 247, 0) 23.94%,
      rgba(242, 244, 247, 0.8) 100%
    );
    pointer-events: none;
    z-index: 2;

    box-shadow: inset 0 -40px 40px -20px white;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(
      0deg,
      rgba(242, 244, 247, 0) 23.94%,
      rgba(242, 244, 247, 0.8) 100%
    );

    box-shadow: inset 0 40px 40px -20px white;
    pointer-events: none;
    z-index: 2;
  }

  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    height: 340px;
  }
`;
const ImageStyle = styled.img`
  width: 200px;

  @media (max-width: 1024px) and (min-width: 768px) {
    width: 200px;
  }

  @media (max-width: 767px) {
   width: 120px;
  }
`;
